import styled from 'styled-components';
import { MediaQuery } from 'octa-front-sdk';
import PageStyles from '../../components/Page/styles';

const Container = styled.div`
  width: 100%;

  ${PageStyles.Container} {
    max-width: unset;
    padding: unset;

    ${MediaQuery.BiggerThanSmall} {
      max-width: unset;
      padding-top: 90px;
    }
  }
`;

const DishesPageStyles = { Container };

export default DishesPageStyles;
